export default __webpack_public_path__ + "static/media/Planhyvlat 8.1dda80a8.jpg";